import { createSlice } from '@reduxjs/toolkit';

import {
  asyncStateInitial,
  finishLoading,
  requestFailedMatcher,
  resetLoadingOnRequestFailed,
  startLoading,
} from '../async-state';
import { type IProductWatchdogAdmin, type IWatchdogState } from './types';

export const preloadedState: IWatchdogState = {
  ...asyncStateInitial,
  watchdogs: undefined,
  deleteInProcess: false,
  sendInProcess: false,
};

const watchdogSlice = createSlice({
  name: 'Watchdog',
  initialState: preloadedState,
  reducers: {
    watchdogLoadAll(state) {
      startLoading(state);
    },
    watchdogLoadAllResponse: {
      reducer(
        state,
        action: { payload: { watchdogs: IProductWatchdogAdmin[] } },
      ) {
        state.watchdogs = action.payload.watchdogs;
        finishLoading(state);
      },
      prepare(watchdogs: IProductWatchdogAdmin[]) {
        return { payload: { watchdogs } };
      },
    },
    watchdogDeleteMany: {
      reducer(state) {
        state.deleteInProcess = true;
      },
      prepare(uuids: string[]) {
        return { payload: { uuids } };
      },
    },
    watchdogDeleteManyResponse: {
      reducer(state, action: { payload: { uuids: string[] } }) {
        state.deleteInProcess = false;
        if (state.watchdogs) {
          state.watchdogs = state.watchdogs.filter(
            (w) => !action.payload.uuids.includes(w.uuid),
          );
        }
      },
      prepare(uuids: string[]) {
        return { payload: { uuids } };
      },
    },
    watchdogSendNow: {
      reducer(state) {
        state.sendInProcess = true;
      },
      prepare(uuids: string[]) {
        return { payload: { uuids } };
      },
    },
    watchdogSendNowResponse: {
      reducer(state, action: { payload: { uuids: string[] } }) {
        state.sendInProcess = false;
        if (state.watchdogs) {
          state.watchdogs = state.watchdogs.filter(
            (w) => !action.payload.uuids.includes(w.uuid),
          );
        }
      },
      prepare(uuids: string[]) {
        return { payload: { uuids } };
      },
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      requestFailedMatcher('Watchdog'),
      resetLoadingOnRequestFailed,
    );
  },
});

export const {
  watchdogLoadAll,
  watchdogLoadAllResponse,
  watchdogDeleteMany,
  watchdogDeleteManyResponse,
  watchdogSendNow,
  watchdogSendNowResponse,
} = watchdogSlice.actions;
export default watchdogSlice.reducer;
